import React from 'react'

import { SelectDropdownList } from '../components/input-select-dropdownlist'
import { SelectField } from '../components/input-select-field'
import { SelectHelperText } from '../components/input-select-helpertext'

export function useSplitChildren(children: React.ReactNode) {
  const childrenArray = React.Children.toArray(children)

  const dropdownElement = childrenArray.find(
    child => React.isValidElement(child) && child.type === SelectDropdownList
  )

  const helperTextExists = childrenArray.some(child => {
    if (!React.isValidElement(child)) return false

    if (child.type === SelectHelperText) return true

    if (child.type === SelectField) {
      const fieldChildren = React.Children.toArray(child.props.children)
      return fieldChildren.some(
        nestedChild =>
          React.isValidElement(nestedChild) &&
          nestedChild.type === SelectHelperText
      )
    }

    return false
  })

  return {
    dropdownElement,
    otherElements: childrenArray.filter(
      child => React.isValidElement(child) && child.type !== SelectDropdownList
    ),
    helperTextExists,
  }
}
